// frontend/src/components/EnhancedInsuranceIcons/gsapSetup.js
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';

// Register the plugin
gsap.registerPlugin(MotionPathPlugin);